import { render, staticRenderFns } from "./ContinueWithSocialAccountButton.vue?vue&type=template&id=37bb0ae8&"
import script from "./ContinueWithSocialAccountButton.vue?vue&type=script&lang=js&"
export * from "./ContinueWithSocialAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports